import {
  generateDefaultStyleProperties,
  generateSkinDefaults,
} from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

export const signatureInputSkinDefinitionMap: Record<string, SkinDefinition> = {
  'wixui.skins.TypeOrDrawSignatureInput': {
    radioButtonsBackground: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'regular',
    },
    radioButtonsSelection: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'regular',
    },
    padBackground: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'regular',
    },
    padLineColor: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'regular',
    },
    padLineWidth: {
      type: 'BORDER_SIZE',
      defaultValue: '0px',
      state: 'regular',
    },
    signatureColor: {
      type: 'COLOR',
      defaultValue: 'color_2',
      state: 'regular',
    },
    signatureSize: {
      type: 'TEXT_SIZE',
      defaultValue: '1px',
      state: 'regular',
    },
    clearButtonColor: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'regular',
    },
    padBorderColor: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'regular',
    },
    padBorderWidth: {
      type: 'BORDER_SIZES',
      defaultValue: '1px',
      state: 'regular',
    },
    radioButtonsBorderColor: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'regular',
    },
    radioButtonsBorderWidth: {
      type: 'BORDER_SIZE',
      defaultValue: '1px',
      state: 'regular',
    },
    clearButtonBorderColor: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'regular',
    },
    clearButtonBorderWidth: {
      type: 'BORDER_SIZES',
      defaultValue: '1px',
      state: 'regular',
    },
    padBorderRadius: {
      type: 'BORDER_RADIUS',
      defaultValue: '0px',
      state: 'regular',
    },
    padBoxShadow: {
      type: 'BOX_SHADOW',
      defaultValue: 'none',
      state: 'regular',
    },
    titleColor: {
      type: 'TEXT_COLOR',
      defaultValue: 'color_2',
      state: 'regular',
    },
    titleFont: {
      type: 'FONT',
      defaultValue: 'font_1',
      state: 'regular',
    },
    radioButtonsTextColor: {
      type: 'COLOR',
      defaultValue: 'color_2',
      state: 'regular',
    },
    radioButtonsTextFont: {
      type: 'FONT',
      defaultValue: 'font_1',
      state: 'regular',
    },
    clearButtonTextColor: {
      type: 'COLOR',
      defaultValue: 'color_2',
      state: 'regular',
    },
    clearButtonTextFont: {
      type: 'FONT',
      defaultValue: 'font_1',
      state: 'regular',
    },
    radioButtonsBackgroundHover: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'hover',
    },
    radioButtonsSelectionHover: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'hover',
    },
    padBackgroundHover: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'hover',
    },
    padLineColorHover: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'hover',
    },
    padLineWidthHover: {
      type: 'BORDER_SIZE',
      defaultValue: '3px',
      state: 'hover',
    },
    clearButtonColorHover: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'hover',
    },
    padBorderColorHover: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'hover',
    },
    padBorderWidthHover: {
      type: 'BORDER_SIZES',
      defaultValue: '1px',
      state: 'hover',
    },
    radioButtonsBorderColorHover: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'hover',
    },
    radioButtonsBorderWidthHover: {
      type: 'BORDER_SIZE',
      defaultValue: '1px',
      state: 'hover',
    },
    clearButtonBorderColorHover: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'hover',
    },
    clearButtonBorderWidthHover: {
      type: 'BORDER_SIZES',
      defaultValue: '1px',
      state: 'hover',
    },
    radioButtonsBackgroundFocus: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'focus',
    },
    padBackgroundFocus: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'focus',
    },
    padLineColorFocus: {
      type: 'COLOR',
      defaultValue: 'color_2',
      state: 'focus',
    },
    padLineWidthFocus: {
      type: 'TEXT_SIZE',
      defaultValue: '1px',
      state: 'focus',
    },
    padBorderColorFocus: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'focus',
    },
    padBorderWidthFocus: {
      type: 'BORDER_SIZES',
      defaultValue: '1px',
      state: 'focus',
    },
    radioButtonsBorderColorFocus: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'focus',
    },
    radioButtonsBorderWidthFocus: {
      type: 'BORDER_SIZE',
      defaultValue: '1px',
      state: 'focus',
    },
    radioButtonsBackgroundError: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'error',
    },
    padBackgroundError: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_0',
      state: 'error',
    },
    padLineColorError: {
      type: 'COLOR',
      defaultValue: 'color_2',
      state: 'error',
    },
    padLineWidthError: {
      type: 'TEXT_SIZE',
      defaultValue: '1px',
      state: 'error',
    },
    padBorderColorError: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_3',
      state: 'error',
    },
    padBorderWidthError: {
      type: 'BORDER_SIZES',
      defaultValue: '1px',
      state: 'error',
    },
    radioButtonsBorderColorError: {
      type: 'COLOR_ALPHA',
      defaultValue: 'color_2',
      state: 'error',
    },
    radioButtonsBorderWidthError: {
      type: 'BORDER_SIZE',
      defaultValue: '1px',
      state: 'error',
    },
  },
};

export const defaultStyleProperties = generateDefaultStyleProperties(
  signatureInputSkinDefinitionMap,
);

export default generateSkinDefaults(signatureInputSkinDefinitionMap);
